import {
    AcceptIcon,
    Button,
    ErrorIcon,
    Flex,
    Skeleton,
    Text,
    Tooltip,
} from "@fluentui/react-northstar";
import moment from "moment";
import styled, { css } from "styled-components";
import { useNavigate } from "react-router-dom";

const Card = ({
    action,
    actionText,
    icon,
    ButtonIcon,
    isPrimary,
    isLoading,
    isFetching,
    due_date,
    status,
    el,
    $isDone = false,
}) => {
    const navigate = useNavigate();

    const isDuedateAfterToday = moment().isAfter(moment(due_date), "day");

    return (
        <CardStyle
            onClick={() => {
                return navigate(
                    `/tasks/${el?.id}/user/${el?.assigned_to_user.id}/detail`,
                    { state: { key: true } }
                );
            }}
            space="between"
            vAlign="center"
            fill
        >
            <Flex fill space="between" vAlign="center">
                <Flex vAlign="center">
                    <Flex styles={{ width: "24px", marginRight: "8px" }}>
                        {isLoading || isFetching ? (
                            <Skeleton>
                                <Skeleton.Text
                                    size="medium"
                                    style={{ width: "20px" }}
                                />
                            </Skeleton>
                        ) : !status ? (
                            isDuedateAfterToday && (
                                <Tooltip
                                    content={`Date d'échéance : ${due_date}`}
                                    pointing
                                    subtle={false}
                                    position="after"
                                    align="start"
                                    trigger={<ErrorIcon />}
                                />
                            )
                        ) : (
                            icon
                        )}
                    </Flex>
                    <Flex fill vAlign="center" style={{ gap: "24px" }}>
                        {isLoading || isFetching ? (
                            <Skeleton>
                                <Skeleton.Text
                                    size="large"
                                    styles={{ width: "120px" }}
                                />
                            </Skeleton>
                        ) : (
                            <CardText
                                truncated
                                content={actionText}
                                $isDone={$isDone}
                            />
                        )}
                    </Flex>
                </Flex>
                <Flex>
                    {isLoading || isFetching ? (
                        <Skeleton vAlign="center">
                            <Skeleton.Button
                                size="small"
                                animation={"wave"}
                                styles={{ borderRadius: "4px" }}
                            />
                        </Skeleton>
                    ) : action ? (
                        <ButtonStyle
                            tinted
                            icon={ButtonIcon}
                            content={action}
                            flat
                            primary={isPrimary}
                            size="small"
                        />
                    ) : $isDone ? (
                        <SButtonDone>
                            <AcceptIcon size="smaller" /> Fait
                        </SButtonDone>
                    ) : null}
                </Flex>
            </Flex>
        </CardStyle>
    );
};

export default Card;

const SButtonDone = styled.button`
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 5px 12px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    border: 1px solid var(--border);
    font-family: inherit;
    white-space: nowrap;
    background: var(--green-light);
    color: var(--green-dark);
    border-color: #c0dd97;
`;

const ButtonStyle = styled(Button)`
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 5px 12px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    border: 1px solid var(--border);
    font-family: inherit;
    white-space: nowrap;
    background: white;
    color: var(--purple);
    :hover {
        border-color: var(--purple);
        background: var(--purple-light);
    }
`;

const CardText = styled(Text)`
    font-size: 13px;
    color: var(--text);
    flex: 1;
    font-weight: 600;
    ${({ $isDone }) =>
        $isDone &&
        css`
            color: var(--text-tert);
            text-decoration: line-through;
        `}
`;

const CardStyle = styled(Flex)`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 11px 18px;
    border-bottom: 1px solid var(--border);
    transition: background 0.12s;
    cursor: pointer;
    :hover {
        background: var(--bg);
    }
`;
